import SectionHeading from '@/components/base/SectionHeading';
import { beginnerEssentials } from '@/mocks/mt4mt5Page';

const toneClasses: Record<string, { tile: string; dot: string }> = {
  primary: { tile: 'bg-primary-100 text-primary-700', dot: 'bg-primary-500' },
  accent: { tile: 'bg-accent-100 text-accent-700', dot: 'bg-accent-500' },
  secondary: { tile: 'bg-secondary-100 text-secondary-900', dot: 'bg-secondary-500' },
};

export default function BeginnerEssentials() {
  return (
    <section id="essentials" className="scroll-mt-24 border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <SectionHeading
          eyebrow="มือใหม่ควรรู้"
          title="6 เรื่องที่มือใหม่มักสะดุดก่อนเริ่มใช้ MT4 และ MT5"
          subtitle="ไม่ได้อยู่ในเมนูไหนของแพลตฟอร์ม แต่เป็นเรื่องที่เจอแน่ ๆ ในสัปดาห์แรก รู้ไว้ก่อนจะเสียเวลาไล่หาสาเหตุ"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {beginnerEssentials.map((item, index) => {
            const tone = toneClasses[item.tone] ?? toneClasses.primary;
            return (
              <article
                key={item.title}
                className="flex flex-col rounded-xl border border-background-200 bg-background-100/60 p-5 md:p-6"
              >
                <div className="flex items-start justify-between gap-3">
                  <span
                    aria-hidden="true"
                    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${tone.tile}`}
                  >
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <span className="font-num text-xs font-semibold text-foreground-400">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>

                <h3 className="mt-4 font-heading text-base font-semibold leading-snug text-foreground-950">
                  {item.title}
                </h3>

                <ul className="mt-3 flex flex-col gap-2">
                  {item.points.map((point) => (
                    <li key={point} className="flex items-start gap-2.5">
                      <span aria-hidden="true" className={`mt-[7px] h-1 w-1 shrink-0 rounded-full ${tone.dot}`} />
                      <span className="text-sm leading-relaxed text-foreground-600">{point}</span>
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>

        <p className="mt-8 flex items-start gap-3 rounded-lg border border-background-200 bg-background-100/60 p-4 text-xs leading-relaxed text-foreground-600 md:text-sm">
          <i className="ri-information-line mt-0.5 shrink-0 text-base text-primary-600" aria-hidden="true" />
          รายละเอียดบางอย่าง เช่น เวลาเซิร์ฟเวอร์ จำนวนหลักของ Lot และส่วนต่อท้ายชื่อคู่เงิน
          อาจแตกต่างกันตามโบรกเกอร์ที่คุณใช้ ถ้าเจอค่าที่ไม่ตรงกับที่อ่าน ให้ยึดข้อมูลจากโบรกเกอร์เป็นหลัก
        </p>

        <a
          href="#faq"
          className="mt-4 inline-flex cursor-pointer items-center gap-1.5 text-xs font-medium text-primary-700 transition-colors hover:text-primary-600 md:text-sm"
        >
          ทั้ง 6 เรื่องนี้มีคำตอบแบบละเอียดอยู่ในหัวข้อคำถามที่พบบ่อย
          <i className="ri-arrow-down-line text-base" aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}